<template>
  <v-dialog v-model="visible" max-width="85vw" max-height="70vh">
    <v-card>
      <!-- Toolbar del modal -->
      <v-toolbar color="#00819d" dark>
        <v-toolbar-title>
          {{ poblacio }}, {{ provincia }}, ({{ zona }})
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="tancar">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <!-- Contingut -->
      <v-card-text class="pa-0" style="height: 58vh;">
        <iframe
          :src="urlMapa"
          width="100%"
          height="100%"
          frameborder="0"
        ></iframe>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  modelValue: { type: Boolean, required: true }, // controla obert/tancat
  urlMapa: { type: String, required: true },
  provincia: { type: String, default: '' },
  poblacio: { type: String, default: '' },
  zona: { type: String, default: '' },
})

const emit = defineEmits(['update:modelValue'])

const visible = computed({
  get: () => props.modelValue,
  set: (v) => emit('update:modelValue', v)
})

function tancar() {
  visible.value = false
}
</script>
